<template>
  <div>
    <a-row class="row">
      <a-col :span="2" class="title" style="margin-right:0;margin-left:180px;margin-top:4px;">邮件模板：</a-col>
      <a-col :span="3">
        <a-select
          style="width: 250px;"
          placeholder="请选择"
          @change="selectChange"
          v-model="templateCode"
        >
          <a-select-option
            v-for="(item,index) in emailTemplates"
            :value="item.templateCode"
            :key="index"
          >{{item.name}}（{{item.lang}}）</a-select-option>
        </a-select>
      </a-col>
    </a-row>

    <a-row class="row">
      <a-col :span="2" class="title" style="margin-left:180px;margin-top:4px;">邮件标题：</a-col>
      <a-col :span="2">
        <a-input v-model="emailTemplate.title" :readOnly="true" style="width:250px;"/>
      </a-col>
    </a-row>
    <a-row class="row">
      <a-col :span="2" class="title" style="margin-left:180px;margin-top:4px;">邮件内容：</a-col>
      <a-col :span="16">
        <a-textarea
          style="height:400px;width:700px"
          v-model="firstContent"
          id="textarea"
          :readOnly="true"
        ></a-textarea>
      </a-col>
    </a-row>
    <a-row class="row">
      <a-col :span="2" class="title" style="margin-left:180px;margin-top:4px;">短信内容：</a-col>
      <a-col :span="8">
        <a-textarea id="message_content" value="发短信..." :readOnly="true" style="height:100px;"></a-textarea>
      </a-col>
      <br>
      <a-col :span="4">
        <a-checkbox id="send_message" style="margin-left:20px;margin-top:14px;">发送短信</a-checkbox>
      </a-col>
    </a-row>
    <a-row class="row" style="margin-left:550px;margin-top:50px;">
      <a-button id="noSend" name="btn" class="btn" @click="noSend">取消</a-button>
      <a-button id="preview" name="btn" class="btn" @click="preview">预览</a-button>
      <a-button id="send" name="btn" class="btn" @click="send">发送</a-button>
    </a-row>
    <a-modal
      title="预览"
      v-model="visible"
      cancelText="关闭"
      okText="发送"
      @ok="send"
      @cancel="cancelPreview"
      centered
      width="800px"
    >
      <div>
        <a-row class="row">
          <a-col :span="4" class="title">邮件标题：</a-col>
          <a-col :span="12">
            <a-input v-model="emailTemplate.title" :readOnly="true"/>
          </a-col>
        </a-row>
        <a-row class="row">
          <a-col :span="4" class="title">邮件内容：</a-col>
          <a-col :span="18">
            <a-textarea style="height:350px;width:700px;" v-model="firstContent" id="textarea" :readOnly="true"></a-textarea>
          </a-col>
        </a-row>
      </div>
    </a-modal>
  </div>
</template>

<script>
import qs from "qs";
export default {
  name: "callAudit",
  data() {
    return {
      visible: false,
      code: "",
      emailTemplates: [],
      emailTemplate: { content: "", title: "" },
      email:"",
      templateCode: "",
      templateType: "",
      isSend: true,
      firstContent: ""
    };
  },
  created() {
    this.code = this.$route.query.code;
    this.templateType = this.$route.query.templateType;

    this.axios
      .get("/emailTemplate/queryEmailTemplate", {
        params: {
          templateType: this.templateType,
          sortField: "template_code",
          page: 1,
          limit: 10,
          time: new Date().getTime()
        },
        paramsSerializer: function(p) {
          return qs.stringify(p, { arrayFormat: "repeat" });
        }
      })
      .then(res => {
        if (res.data.code == "0") {
          if (res.data.data.length == 0) {
            this.utils.messageInfo(this,"error","查询邮件模版失败！");
            this.isSend = false;
            return;
          }
          this.emailTemplates = res.data.data;
          this.emailTemplates.forEach(function(value) {
            if (value.lang == "CN") {
              value.lang = "中文";
            } else if (value.lang == "EN") {
              value.lang = "英文";
            }
          });
          this.emailTemplate = this.emailTemplates[0];
          this.templateCode = this.emailTemplate.templateCode;

          //查询邮件内容
          this.getContent();
        } else {
          this.utils.messageInfo(this,"error","查询邮件模版失败！");
        }
      });
  },
  methods: {
    cancelPreview() {
      this.visible = false;
    },
    getContent() {
      this.axios
        .get("/email/callAuditContent", {
          params: {
            code: this.code,
            emailContent: this.emailTemplate.content,
            time: new Date().getTime()
          },
          paramsSerializer: function(p) {
            return qs.stringify(p, { arrayFormat: "repeat" });
          }
        })
        .then(res => {
          this.firstContent = res.data.emailContent;
          this.email = res.data.email;
        });
    },
    selectChange(value) {
      var tmp = {};
      this.emailTemplates.forEach(function(v) {
        if (v.templateCode == value) {
          tmp = v;
        }
      });
      this.emailTemplate = tmp;
      this.templateCode = this.emailTemplate.templateCode;

      //查询邮件内容
      this.getContent();
    },
    noSend() {
      this.$router.push("/notBack");
    },
    preview() {
      this.visible = true;
    },
    send() {
      if (!this.isSend) {
        this.utils.messageInfo(this,"error","无法发送邮件！");
        return;
      }
      //发送邮件
      this.axios
        .post("/email/auditSend", {
          email: this.email,
          subject: this.emailTemplate.title,
          text: this.firstContent
        })
        .then(res => {
          if (res.data.code == "OK") {
            this.$router.push("/notBack");
          } else {
            this.utils.messageInfo(this,"error","发送失败！");
          }
        });
    }
  }
};
</script>

<style scoped>
.row {
  margin-top: 20px;
  margin-bottom: 20px;
}
.btn {
  color: #1890ff;
  border-color: #1890ff;
  margin: 0 10px;
}
#send {
  color: #fff;
  background-color: #1890ff;
  border-color: #1890ff;
}
#send_message {
  margin-left: 20px;
}
</style>
